import React from 'react';
import { Link } from 'react-router-dom';

const FOOTER_LINKS = {
  Loan: [['/emi', 'EMI Calculator'], ['/home-loan', 'Home Loan EMI'], ['/car-loan', 'Car Loan EMI'], ['/business-loan', 'Business Loan'], ['/reducing-rate', 'Reducing Rate']],
  Investment: [['/sip', 'SIP Calculator'], ['/fd', 'FD Calculator'], ['/rd', 'RD Calculator'], ['/ppf', 'PPF Calculator'], ['/epf', 'EPF Calculator'], ['/ssy', 'SSY Calculator']],
  Tax: [['/income-tax', 'Income Tax'], ['/gst', 'GST Calculator'], ['/hra', 'HRA Calculator'], ['/tds', 'TDS Calculator'], ['/capital-gain', 'Capital Gain']],
  Business: [['/profit-margin', 'Profit Margin'], ['/depreciation', 'Depreciation'], ['/brokerage', 'Brokerage'], ['/salary', 'Salary Calculator'], ['/stock-average', 'Stock Average']],
  Policy: [['/privacy-policy', 'Privacy-policy'], ['/termsConditions', 'Terms & Conditions'], ['/disclaimer', 'Disclaimer']],
};

export default function Footer() {
  const linkStyle = {
    display: 'block', fontSize: '13px', color: 'var(--t2)', textDecoration: 'none',
    marginBottom: '7px', transition: 'color 0.18s',
  };
  const hoverOn = e => e.currentTarget.style.color = 'var(--orange)';
  const hoverOff = e => e.currentTarget.style.color = 'var(--t2)';

  return (
    <footer style={{ background: 'var(--bg2)', borderTop: '1px solid var(--border)', marginTop: '40px', padding: '40px 16px 24px', transition: 'background 0.3s' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Top row */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '28px', marginBottom: '36px' }}>
          {/* Brand */}
          <div style={{ gridColumn: 'span 1' }}>
            <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '9px', marginBottom: '14px' }}>
              <div style={{ width: '32px', height: '32px', background: 'linear-gradient(135deg,var(--orange),var(--orange2))', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '17px' }}>🧮</div>
              <span style={{ fontWeight: 800, fontSize: '15px', color: 'var(--t1)' }}>Apnaa Calculator</span>
            </Link>
            <p style={{ fontSize: '13px', color: 'var(--t2)', lineHeight: 1.7, marginBottom: '14px' }}>
              India's most comprehensive free financial calculator app. 30+ calculators for every financial need.
            </p>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {['🇮🇳 Made for India', '100% Free', '30+ Calculators'].map(t => (
                <span key={t} style={{ fontSize: '11px', background: 'rgba(255,107,44,0.1)', border: '1px solid rgba(255,107,44,0.2)', color: 'var(--orange)', borderRadius: '20px', padding: '3px 10px', fontWeight: 600 }}>{t}</span>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(FOOTER_LINKS).map(([cat, links]) => (
            <div key={cat}>
              <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--t3)', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '12px' }}>{cat}</div>
              {links.map(([p, n]) => (
                <Link key={p} to={p} style={linkStyle} onMouseEnter={hoverOn} onMouseLeave={hoverOff}>{n}</Link>
              ))}
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
          <span style={{ fontSize: '12px', color: 'var(--t3)' }}>©{new Date().getFullYear()} Apnaa Calculator. All rights reserved.</span>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            {/* <Link to="/admin" style={{ fontSize: '12px', color: 'var(--t3)', textDecoration: 'none' }} onMouseEnter={hoverOn} onMouseLeave={hoverOff}>⚙️ Admin Panel</Link> */}
            <span style={{ fontSize: '12px', color: 'var(--t3)' }}>Made with ❤️ for India 🇮🇳</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
